import { Menu, X, ArrowRight } from 'lucide-react';
import { useState } from 'react';

export function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = ['Services', 'About', 'Case Studies', 'Contact'];

  const scrollToSection = (item: string) => {
    const id = item.toLowerCase().replace(' ', '-');
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass border-b border-gray-200/50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div
            className="text-2xl font-extrabold gradient-text-premium cursor-pointer hover:scale-105 transition-transform"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <img src={require("../assets/text_logo.png")} width={220} height={"auto"} alt={"ZeeJay Labs Logo"}/>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item)}
                className="px-5 py-2.5 text-gray-700 hover:text-blue-600 transition-colors font-semibold rounded-lg hover:bg-gray-50"
              >
                {item}
              </button>
            ))}
            <button
              onClick={() => scrollToSection('Contact')}
              className="group ml-4 px-6 py-3 text-white rounded-xl transition-all hover:shadow-lg hover:shadow-blue-500/30 hover:-translate-y-0.5 font-bold flex items-center gap-2"
              style={{backgroundColor:"#5e077a"}}
            >
              <span>Get Started</span>
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden flex flex-col gap-2 pb-4 animate-fadeInUp">
            {navItems.map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item)}
                className="px-4 py-3 text-left text-gray-700 hover:text-blue-600 hover:bg-gray-50 transition-colors font-semibold rounded-lg"
              >
                {item}
              </button>
            ))}
            <button
              onClick={() => scrollToSection('Contact')}
              className="mt-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all font-bold flex items-center justify-center gap-2"
            >
              <span>Get Started</span>
              <ArrowRight size={16} />
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}